import {ExclamationCircleOutlined, MoreOutlined} from "@ant-design/icons";
import {Button, Dropdown, Menu, Modal, message} from "antd";
import {Link} from "react-router-dom";
import {useDeleteDiscountCode} from "../../../../../react-query-hooks/discounts/discounts";
import {useGetDiscountCodesContext} from "../../context";

type DiscountCodesTableMenuOptionsProps = {
  codeId: number;
  code: string;
  page: number;
};

export function DiscountCodesTableMenuOptions({
  codeId,
  code,
  page,
}: DiscountCodesTableMenuOptionsProps) {
  const deleteDiscountCodeMutation = useDeleteDiscountCode();
  //   const getProfileQuery = useGetProfile();
  const {
    state: {discountCodes, currentPage},
    dispatch,
  } = useGetDiscountCodesContext();
  const handleDeleteModal = () => {
    Modal.confirm({
      title: `Confirm discount code deletion`,
      content:
        "Are you sure you want to delete this discount code? This action cannot be undone.",
      icon: <ExclamationCircleOutlined style={{color: "#F5222D"}} />,
      okText: "Delete code",
      cancelText: "Exit",
      okType: "danger",
      okButtonProps: {
        size: "small",
        type: "primary",
        loading: deleteDiscountCodeMutation.isLoading,
      },
      cancelButtonProps: {
        size: "small",
        type: "ghost",
      },
      onOk() {
        return new Promise((resolve, reject) => {
          if (codeId) {
            resolve(deleteDiscountCodeMutation.mutate({codeId, page}));
          }
        }).catch(() => message.error("Failed to delete"));
      },
    });
  };
  const menu = (
    <Menu
      items={[
        {
          label: (
            <Link to={`/discounts/${codeId}/view`}>
              <div>View details</div>
            </Link>
          ),
          key: "view",
        },
        {
          label: (
            <div
              onClick={() =>
                navigator.clipboard
                  .writeText(code)
                  .then(() => message.success("Code copied"))
              }
            >
              Copy discount code
            </div>
          ),
          key: "0",
        },
        {
          label: (
            <Link to={`/discounts/edit/${codeId}`}>
              <div>Edit discount code</div>
            </Link>
          ),
          key: "1",
        },
        {
          label: <div onClick={handleDeleteModal}>Delete discount code</div>,
          key: "2",
        },
      ]}
    />
  );
  return (
    <>
      <Dropdown overlay={menu} trigger={["click"]} placement="bottomRight">
        <Button
          shape="circle"
          size="small"
          icon={<MoreOutlined />}
          style={{
            backgroundColor: "transparent",
            color: "#1C1726",
            border: "none",
            boxShadow: "none",
          }}
        />
      </Dropdown>
    </>
  );
}
